"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6439],{

/***/ 23443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ toolsFeatures; },
/* harmony export */   "Z": function() { return /* binding */ ASSET_URL; }
/* harmony export */ });
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);

var ASSET_URL = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .assetPrefix */ .Vc, "/homepage/proimage/");
var toolsFeatures = [
    {
        title: "Financials",
        url: "financials",
        description: "Pelajari Data Laporan Keuangan",
        icon: "landingicon_Financials.svg",
        features: [
            {
                title: "Berbagai Tampilan Periode",
                description: "Pilih periode data keuangan perusahaan yang ingin kamu liat, mulai dari per kuartal (Quarterly), tahunan (Annual), 12 bulan kebelakang (TTM) ataupun Year-To-Date (YTD)."
            },
            {
                title: "Grafik Tren & Rasio Keuangan",
                description: "Lihat tren pendapatan, laba bersih dan akun lainnya berdasarkan data historikal. Juga dilengkapi rasio keuangan untuk memudahkan analisa Anda."
            },
            {
                title: "Pertumbuhan Perusahaan",
                description: "Cari tau bagaimana pertumbuhan pendapatan atau laba bersih perusahaan sesuai periode yang diinginkan, Quarter-on-Quarter atau Year-on-Year hanya dengan 2 klik."
            },
            {
                title: "Marjin Perusahaan",
                description: "Pelajari dan bandingkan marjin yang dihasilkan perusahaan antar periode. Apakah itu Gross Profit Margin ataupun Net Profit Margin."
            },
            {
                title: "Drag n Drop",
                description: "Bandingkan periode yang kamu butuhkan side by side hanya dengan drag and drop, kamu juga bisa atur sendiri susunan periode laporan keuangan sesuai kebutuhan"
            },
            {
                title: "IDR atau USD",
                description: "Beberapa perusahaan menggunakan USD dalam laporannya, dengan financials kamu bisa liat laporannya tetap dalam USD atau dalam IDR, rubah sesuai kebutuhanmu."
            }, 
        ]
    },
    {
        title: "Keystats",
        url: "keystats",
        description: "Rasio-rasio Fundamental yang Lengkap",
        icon: "landingicon_Keystats.svg",
        features: [
            {
                title: "Valuasi nilai Perusahaan",
                description: "Pelajari data valuasi penting emiten seperti PE ratio, Earning Yield, PBV ratio. Semua dari satu tempat."
            },
            {
                title: "Level Hutang",
                description: "Cari tahu keadaan kesehatan perusahaan dengan melihat level hutang dari rasio-rasio Solvency seperti Current ratio, Debt to Equity ratio, Interest Coverage dan lainnya."
            },
            {
                title: "Alokasi Kas",
                description: "Ketahui dan pelajari Berasal dari mana dan digunakan untuk apa kas yang dimiliki oleh emiten."
            },
            {
                title: "Deviden",
                description: "Liat informasi terkait pembagian dividend perusahaan, berapa jumlah dividend per share yang dibagikan, berapa payout ratio dan berapa besar dividend yield."
            }, 
        ]
    },
    {
        title: "Fundachart",
        url: "fundachart",
        description: "Bandingkan Data Emiten secara Visual",
        icon: "landingicon_Fundachart.svg",
        features: [
            {
                title: "PE Standard Deviation Band",
                description: "Salah satu metode yang sering dipakai oleh institusi untuk melakukan valuasi saham untuk mengetahui apakah saham termasuk murah atau mahal berdasarkan historikal PE Ratio-nya."
            },
            {
                title: "PE Price Band",
                description: "Lihat langsung apakah harga saham saat ini termasuk murah atau mahal. Tentukan dengan mudah titik harga untuk masuk atau keluar dari sebuah saham."
            },
            {
                title: "PBV Standard Deviation Band",
                description: "Salah satu metode yang juga sering digunakan oleh institusi untuk melakukan valuasi saham berdasarkan historikal Price to Book Value-nya."
            }, 
        ]
    },
    {
        title: "Chartbit",
        url: "chartbit",
        description: "Fitur Charting Professional",
        icon: "landingicon_Chartbit.svg",
        features: [
            {
                title: "Real-time Price",
                description: "Data harga yang sama dengan data harga di bursa saat itu juga."
            },
            {
                title: "Intraday Price Interval",
                description: "Periode Harga mulai dari 1 menit, 5,menit, 30 menit, sampai 1 jam."
            },
            {
                title: "Data historikal hingga 15 tahun",
                description: "Lihat trend harga saham sampai dengan 15 tahun kebelakang untuk menganalisa trend jangka panjang."
            },
            {
                title: "100+ Teknikal Indikator",
                description: "Tersedia ratusan indikator siap pakai untuk mempertajam analisa teknikal Anda."
            },
            {
                title: "Bandarmologi",
                description: 'Deteksi dan pelajari gerak bandar, jadilah "teman" bandar untuk membantu kamu mendapatkan keuntungan.'
            },
            {
                title: "Foreign Flow",
                description: "Pantau pergerakan dana asing di saham pilihanmu, apakah net inflow atau outflow. Pelajari juga seberapa kuat transaksi dana asing pada saham tersebut."
            },
            {
                title: "Corporate Action Event",
                description: "Lihat langsung aksi korporasi dan pengaruhnya terhadap pergerakan harga sahamnya."
            }, 
        ]
    },
    {
        title: "Screener",
        url: "screener",
        description: "Cari Saham sesuai Kriteria Kamu",
        icon: "landingicon_Screener.svg",
        features: [
            {
                title: "Guru Screener",
                description: 'Cari saham yang memenuhi kriteria "guru" investasi dunia seperti Warren Buffett, Peter Lynch, Piotroski dan lainnya.'
            },
            {
                title: "Preset Screener",
                description: "Screener Siap pakai untuk mencari saham dengan kriteria yang biasa digunakan oleh investor profesional."
            },
            {
                title: "100+ Rasio-rasio keuangan",
                description: "Data keuangan dan rasio keuangan yang lengkap sehingga kamu bisa menentukan sendiri kriteria saham yang kamu inginkan."
            },
            {
                title: "Ratio Vs Ratio",
                description: "Gunakan perbandingan dua rasio berbeda sebagai kriteria dari screener buatanmu."
            }, 
        ]
    },
    {
        title: "Price Alert",
        url: "price-alert",
        description: "Notifikasi Real-Time Saat Harga Kamu Tercapai",
        icon: "landingicon_Price-Alert.svg",
        features: [
            {
                title: "Push Notification",
                description: "Dapatkan notifikasi langsung di smartphone-mu saat harga saham mencapai harga yang telah kamu tentukan."
            },
            {
                title: "Real-Time Alert",
                description: "Notifikasi yang dikirimkan berdasarkan harga di bursa, sehingga kamu tidak akan ketinggalan momentum."
            }, 
        ]
    },
    {
        title: "Seasonality",
        url: "seasonality",
        description: "Lihat Pergerakan Saham Pada Bulan-bulan Tertentu",
        icon: "landingicon_Seasonality.svg",
        features: [
            {
                title: "Lebih dari 15 Tahun Price History",
                description: "Lihat kebiasaan pergerakan harga setiap bulan, hingga lebih dari 15 tahun kebelakang untuk mengetahui pada bulan apa biasanya harga cenderung naik atau turun."
            },
            {
                title: "Probabilitas Kenaikan",
                description: "Probabilitas kenaikan untuk setiap bulannya akan otomatis terhitung. Hint: $IHSG 100% positif pada bulan Desember selama 16 tahun terakhir."
            }, 
        ]
    },
    {
        title: "Earnings",
        url: "earnings",
        description: "Rangkuman Laba Bersih Perusahaan Setiap Periode",
        icon: "landingicon_Earnings.svg",
        features: [
            {
                title: "Tepat Waktu",
                description: "Lihat rekap laba bersih emiten pilihanmu langsung ketika emiten mengeluarkan laporan keuangan."
            },
            {
                title: "Bandingkan dengan Estimasi Analis",
                description: "Bandingkan laba bersih yang dilaporkan perusahaan dengan estimasi para analis. Apakah di atas estimasi atau di bawah estimasi?"
            },
            {
                title: "Bandingkan dengan Tahun Lalu",
                description: "Bandingkan hasil laba bersih pada kuartal saat ini dengan kuartal yang sama pada tahun sebelumnya."
            }, 
        ]
    },
    {
        title: "Comparison",
        url: "comparison",
        description: "Bandingkan Data Emiten Satu dengan Lainnya",
        icon: "landingicon_Comparison.svg",
        features: [
            {
                title: "Pembanding yang Sesuai",
                description: "Sistem kami secara otomatis akan membantu membandingkan emiten pilihan Anda dengan emiten sejenisnya sehingga tidak perlu lagi repot dan bingung mencari perbandingan emiten yang sesuai."
            },
            {
                title: "Komparasi Secara Rinci",
                description: "Dilengkapi dengan puluhan rasio dan financial metrics, laukan komparasi emiten dari berbagai aspek secara rinci dan mudah. Ditambah adanya angka rata-rata untuk masing-masing industri dan sektor emiten terkait sebagai pembanding untuk membantu memilih emiten yang paling sesuai dengan kriteria."
            }, 
        ]
    }, 
];



/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 55781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": function() { return /* reexport */ LandingPage_PageHeader; },
  "Dr": function() { return /* reexport */ LandingPage_SectionBrowser; },
  "ZG": function() { return /* reexport */ LandingPage_SectionContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
;// CONCATENATED MODULE: ./src/global/LandingPage/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 50px;\n  padding: 0 25px;\n  padding-top: 100px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    padding: 0;\n    padding-top: 120px;\n    width: calc(100% - 151px);\n  }\n\n  @media ",
        " {\n    margin-top: 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n\n  @media ",
        " {\n    padding: 50px 0;\n    width: calc(100% - 150px);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin: auto;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-weight: normal;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var HeaderWrapper = (0,styled_components_browser_esm["default"])(Flex).attrs({
    m: "auto",
    as: "header",
    direction: "column"
}).withConfig({
    componentId: "sc-c0c28dff-0"
})(_templateObject(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var Wrapper = (0,styled_components_browser_esm["default"])(Flex).attrs({
    m: "auto",
    as: "section"
}).withConfig({
    componentId: "sc-c0c28dff-1"
})(_templateObject1(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var HeaderTitle = (0,styled_components_browser_esm["default"])(Text).attrs({
    color: ui/* color.primary */.$_.primary,
    size: "60px",
    height: 1.3,
    family: "bold",
    as: "h1"
}).withConfig({
    componentId: "sc-c0c28dff-2"
})(_templateObject2());
var HeaderDescription = (0,styled_components_browser_esm["default"])(Text).attrs({
    size: "19px",
    m: "0 auto",
    height: 1
}).withConfig({
    componentId: "sc-c0c28dff-3"
})(_templateObject3());


;// CONCATENATED MODULE: ./src/global/LandingPage/PageHeader/index.tsx


function PageHeader(param) {
    var title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDescription, {
                children: description
            })
        ]
    });
}
/* harmony default export */ var LandingPage_PageHeader = (PageHeader);

;// CONCATENATED MODULE: ./src/global/LandingPage/SectionBrowser/styled.ts
/* eslint-disable indent */ /* eslint-disable space-infix-ops */ 
function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media ",
        " {\n    padding: 50px 0;\n    padding-left: 50px;\n    width: 50%;\n  }\n\n  @media ",
        " {\n    width: 60%;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    align-items: flex-start;\n    margin-bottom: 0;\n    padding-right: 50px;\n    width: 50%;\n  }\n\n  @media ",
        " {\n    width: 40%;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        flex-direction: row-reverse;\n        ",
        " {\n          padding-left: 0;\n          padding-right: 50px;\n        }\n\n        ",
        " {\n          padding-left: 50px;\n          padding-right: 0;\n        }\n      "
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n\n  @media ",
        " {\n    align-items: center;\n    flex-direction: row;\n\n    ",
        "\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin: auto;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    text-align: left;\n    margin: unset;\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin: auto;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 18px;\n    margin: unset;\n    text-align: left;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var styled_Text = ui/* Common.Text */.Gn.Text, styled_Flex = ui/* Common.Flex */.Gn.Flex;
var BrowserWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-576a1d7-0"
})(styled_templateObject(), ui/* device.laptop */.Uh.laptop, ui/* device.laptopL */.Uh.laptopL);
var ContentWrapper = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-576a1d7-1"
})(styled_templateObject1(), ui/* device.laptop */.Uh.laptop, ui/* device.laptopL */.Uh.laptopL);
var SectionWrapper = (0,styled_components_browser_esm["default"])(Wrapper).withConfig({
    componentId: "sc-576a1d7-2"
})(styled_templateObject3(), ui/* device.laptop */.Uh.laptop, function(param) {
    var reverse = param.reverse;
    return reverse && (0,styled_components_browser_esm.css)(styled_templateObject2(), BrowserWrapper, ContentWrapper);
});
var Title = (0,styled_components_browser_esm["default"])(styled_Text).attrs({
    as: "h2",
    size: "40px",
    family: "bold"
}).withConfig({
    componentId: "sc-576a1d7-3"
})(_templateObject4(), ui/* device.laptop */.Uh.laptop);
var Description = (0,styled_components_browser_esm["default"])(styled_Text).attrs({
    height: 1.3,
    color: ui/* color.dimgray */.$_.dimgray
}).withConfig({
    componentId: "sc-576a1d7-4"
})(_templateObject5(), ui/* device.laptop */.Uh.laptop);


// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/LandingPage/BrowserBox/styled.ts

function BrowserBox_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  box-shadow: 0 0 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);\n  margin: 20px 0;\n  max-width: 840px;\n  overflow: hidden;\n  padding: 8px;\n  width: 100%;\n"
    ]);
    BrowserBox_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BrowserBox_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px 4px 0 0;\n  height: 24px;\n  padding: 6px 3px;\n\n  .browser-bullet {\n    background: #2f8ef7;\n    border-radius: 10px;\n    float: left;\n    height: 7px;\n    margin-left: 7px;\n    opacity: 0.8;\n    vertical-align: middle;\n    width: 7px;\n\n    :nth-child(1) {\n      background: #fc605c;\n    }\n    :nth-child(2) {\n      background: #fdbc40;\n    }\n    :nth-child(3) {\n      background: #34c84a;\n    }\n  }\n"
    ]);
    BrowserBox_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BrowserBox_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        " no-repeat center top / 100% auto;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgb(0 0 0 / 10%);\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n\n  img {\n    width: 98%;\n    opacity: 0;\n  }\n"
    ]);
    BrowserBox_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var BoxWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f3026a54-0"
})(BrowserBox_styled_templateObject(), ui/* color.component */.$_.component);
var TabToolTop = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f3026a54-1"
})(BrowserBox_styled_templateObject1());
var BrowserContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f3026a54-2"
})(BrowserBox_styled_templateObject2(), ui/* color.light */.$_.light);


;// CONCATENATED MODULE: ./src/global/LandingPage/BrowserBox/index.tsx



function BrowserBox(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToolTop, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserContent, {
                style: {
                    backgroundImage: "url(".concat(image, ")")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image,
                    alt: "browser preview"
                })
            })
        ]
    });
}
/* harmony default export */ var LandingPage_BrowserBox = (BrowserBox);

;// CONCATENATED MODULE: ./src/global/LandingPage/SectionBrowser/index.tsx



function SectionBrowser(param) {
    var reverse = param.reverse, title = param.title, description = param.description, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
        reverse: reverse,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage_BrowserBox, {
                    image: image
                })
            })
        ]
    });
}
/* harmony default export */ var LandingPage_SectionBrowser = (SectionBrowser);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/global/LandingPage/SectionContent/styled.ts

function SectionContent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n\n  @media ",
        " {\n    align-items: flex-start;\n    flex-direction: row;\n  }\n"
    ]);
    SectionContent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionContent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  margin-bottom: 30px;\n  text-align: center;\n  width: 100%;\n\n  @media ",
        " {\n    align-items: flex-start;\n    margin-bottom: 0;\n    text-align: left;\n    width: calc((100% - 201px) / 3);\n  }\n"
    ]);
    SectionContent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionContent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: inherit;\n"
    ]);
    SectionContent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SectionContent_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: no-repeat center right / 16px auto;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAG2SURBVGhD7Zi/LwRREMcHodAo0BGNQohEoqBQEYma+AMUNm7eXaGQiMKV/AEKEqUf2XmH5HqNSqGi1BCdSkIkkuPM25uTW3ul4ibmk0wut+9bzCf73tt9C4ZhGIZhGMY/4jjqg2KxXf4ppApt4J3nqoLHRyCckBFlEM7UJOqFzxDjsIwqIi6MArmvlAy5BzgrDEhCEbHbTokkhbcs2S8JRRDuZWTIXUM56paEEmqL/igj4/ESqNglKSWEhsmVszK8q9Fyh6SUEKYS4VUTmf3krqmCop5ksWdldiTRhHPXC5SbbLmKcYEbf/klUuXrG9J5Ax7XuT4z4Vau8MwhtyIGTG2XyBrrqAo/e+bFhCF31ySkoe7TD8tSfoRlYh64adF65UpLED7BaW5QDBRQckvceCUtwi+UHsckoYA4P8sNf6Qlwt3BKUkoIDTr8S0twVJBTg2xG+emefo0SoTplVuUhAJKOJQs5EaJ5JyCq5JQQNhKw5baKJGI4KYkFBA+OIRzR1ZiVxJKOFubzkh4PNT3phvO5h7ffyQIL/SdPep4nOPpdcK/W3AQdcpVwzAMwzAMw/gLAL4BSNemrTyIDIIAAAAASUVORK5CYII=');\n  color: ",
        ";\n  font-size: 14px;\n  margin-bottom: 15px;\n  padding-right: 30px;\n\n  b {\n    font-family: var(--bold-font);\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    SectionContent_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 30px;\n  width: 100%;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    grid-column-gap: 60px;\n  }\n\n  @media ",
        " {\n    margin-left: 100px;\n    width: calc(2 * ((100% - 101px) / 3));\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  text-align: center;\n  width: 100%;\n\n  @media ",
        " {\n    align-items: flex-start;\n    text-align: left;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 17px;\n  margin-bottom: 10px;\n\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: inherit;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var SectionContent_styled_Flex = ui/* Common.Flex */.Gn.Flex, SectionContent_styled_Text = ui/* Common.Text */.Gn.Text;
var styled_SectionWrapper = (0,styled_components_browser_esm["default"])(Wrapper).withConfig({
    componentId: "sc-91134122-0"
})(SectionContent_styled_templateObject(), ui/* device.laptop */.Uh.laptop);
var TitleWrapper = (0,styled_components_browser_esm["default"])(SectionContent_styled_Flex).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-91134122-1"
})(SectionContent_styled_templateObject1(), ui/* device.laptop */.Uh.laptop);
var styled_Title = (0,styled_components_browser_esm["default"])(SectionContent_styled_Text).attrs({
    as: "h3",
    family: "bold",
    size: "40px",
    mb: "10px",
    height: 1.2
}).withConfig({
    componentId: "sc-91134122-2"
})(SectionContent_styled_templateObject2());
var styled_Description = (0,styled_components_browser_esm["default"])(SectionContent_styled_Flex).attrs({
    as: "a",
    align: "center",
    wrap: "wrap"
}).withConfig({
    componentId: "sc-91134122-3"
})(SectionContent_styled_templateObject3(), ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary);
var FeaturesWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-91134122-4"
})(styled_templateObject4(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var FeatureItemWrapper = (0,styled_components_browser_esm["default"])(SectionContent_styled_Flex).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-91134122-5"
})(styled_templateObject5(), ui/* device.laptop */.Uh.laptop);
var FeatureItemTitle = (0,styled_components_browser_esm["default"])(SectionContent_styled_Text).attrs({
    family: "bold",
    as: "h4"
}).withConfig({
    componentId: "sc-91134122-6"
})(_templateObject6(), ui/* device.tablet */.Uh.tablet);
var FeatureDescription = (0,styled_components_browser_esm["default"])(SectionContent_styled_Text).attrs({
    color: ui/* color.dimgray */.$_.dimgray,
    size: "16px",
    height: 1.3
}).withConfig({
    componentId: "sc-91134122-7"
})(_templateObject7());


;// CONCATENATED MODULE: ./src/global/LandingPage/SectionContent/index.tsx







function SectionContent(_param) {
    var title = _param.title, label = _param.label, icon = _param.icon, url = _param.url, features = _param.features, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "label",
        "icon",
        "url",
        "features"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_SectionWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Title, {
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Description, {
                            children: [
                                "Selengkapnya tentang \xa0 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: title
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: icon,
                        alt: title,
                        style: {
                            width: "50px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesWrapper, {
                children: features.map(function(feature) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeatureItemWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItemTitle, {
                                children: feature.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureDescription, {
                                children: feature.description
                            })
                        ]
                    }, feature.title);
                })
            })
        ]
    }));
}
/* harmony default export */ var LandingPage_SectionContent = (SectionContent);

;// CONCATENATED MODULE: ./src/global/LandingPage/index.ts





/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

}]);